import { useEffect, useState } from "react"
import classes from './AddNationalStudygroup.module.css'
import CourseBuildCompletion from "../../Courses/NewCourse/CourseBuildCompletion"
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import * as PathRouter from '../../../../models/PathRoute'


const AddNationalStudygroup = () => {

    const [studyGroup, setStudyGroup] = useState()
    const { disciplinId, studyGroupId } = useParams();
    const location = useLocation();
    const disciplineName = location.state && location.state.disciplineName;
    const texts = useSelector((state) => state.translate.texts);
    const { homeUrl } = useSelector((state) => state.application);
    const navigate = useNavigate()

    useEffect(() => {
        setStudyGroup(
            { id: studyGroupId, courseId: disciplinId, subject: disciplineName, description: disciplineName }
        )
    }, [studyGroupId, disciplinId])

    const handleChangeStudyGroupDescription = (description) => {
        setStudyGroup((prevStudyGroup) => ({ ...prevStudyGroup, description: description }))
    }

    return (
        <div className={classes.AddNationalStudygroup}>
            {studyGroup && <CourseBuildCompletion studyGroup={studyGroup} handleChangeStudyGroupDescription={handleChangeStudyGroupDescription} newNationalStudyGroup={true}> </CourseBuildCompletion>}
            <button className={classes.CourseBuildCompletionBtn} onClick={() => navigate(`${homeUrl}/${PathRouter.ADMIN}/${PathRouter.DISCIPILINES}`)}>{texts.end}</button>
        </div >)
}
export default AddNationalStudygroup